import React, { Component } from "react"
import styled from "styled-components"

import { H1, H4, Container, AbsoluteImg } from "../general/GeneralStyles"

const HeroContainer = styled(Container)`
  padding: 106px 0 8px 0;

  @media (max-width: ${props => props.theme.mediumBreakpoint }) {
    ${AbsoluteImg} {
      display: none;
    }
  }
`

const Steps = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 780px;
  margin: 0 auto;
  margin-top: 64px;

  @media (max-width: ${props => props.theme.smallBreakpoint }) {
    flex-direction: column !important;
  }
`

const Step = styled.div`
  text-align: center;

  img {
    margin-bottom: 0;
  }

  h3 {
    /* Change this when image changes */
    margin-top: -19px;
    
    font-family: ${props => props.theme.secondaryFont};
    color: ${props => props.theme.primaryColor};
    font-size: 32px;
    font-weight: bold;
    line-height: 32px;
    text-align: center;
    margin-bottom: 0px;
  }

  span {
    color: ${props => props.theme.primaryTextColor};
    font-family: ${props => props.theme.secondaryFont};
    font-size: 32px;
    font-weight: 500;
    line-height: 32px;
    text-align: center;
  }

  @media (max-width: ${props => props.theme.smallBreakpoint }) {
    margin-bottom: 50px;
  }
`

const stepsData = [
  {
    title: "Step 1:",
    subtitle: "Clip UPC Codes",
    img: "step1.png",
  },
  {
    title: "Step 2:",
    subtitle: "Bank Points",
    img: "step2.png",
  },
  {
    title: "Step 3:",
    subtitle: "Get Free Products",
    img: "step3.png",
  },
]

const HeroCoupon = styled(AbsoluteImg)`
  top: 0;
  right: 0;
`

const Pencils = styled(AbsoluteImg)`
  top: 0;
  left: 7.6%;
`

const Hero = props => {
  return (
    <HeroContainer>
      {/* Absolute Images */}
      <HeroCoupon
        id="herocoupon"
        src="/images/absolute/hero-coupon.png"
        alt="herocoupon"
      />
      <Pencils
        id="herocoupon"
        src="/images/absolute/pencils.png"
        alt="herocoupon"
      />
      {/* End Absolute Images */}
      <H1>Earn Free School {"&"} Art Supplies</H1>
      <H4>Join Prang Power and start earning today!</H4>
      <Steps>
        {stepsData.map(step => (
          <Step>
            <img src={"/images/" + step.img} alt="" />
            <h3>{step.title}</h3>
            <span>{step.subtitle}</span>
          </Step>
        ))}
      </Steps>
    </HeroContainer>
  )
}

export default Hero
